import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/printful.constant";

export {
    addPrintfulProductVariants,
    addSinglePrintfulProductVariants,
    updateSinglePrintfulProductVariants,
    getAllPrintfulProductVariants,
    getSinglePrintfulProductVariants,
    searchPrintfulProductVariants,
    searchPrintfulProductVariantsWithSearchCriteria,
    preparePrintfulProductVariantsList
}

const collectionName = 'printful-product-variants';
const collectionReference = collection(fireStoreDB, collectionName);

const addPrintfulProductVariants = (printfulProductVariants) => {
    return Promise.map(printfulProductVariants, async printfulProductVariants => {
        await addSinglePrintfulProductVariants(printfulProductVariants);
    });
}

const addSinglePrintfulProductVariants = (printfulProductVariants) => {
    printfulProductVariants.createdAt = new Date();
    printfulProductVariants.updatedAt = printfulProductVariants.createdAt;
    return addDoc(collectionReference, printfulProductVariants);
}

const updateSinglePrintfulProductVariants = (printfulProductVariants) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulProductVariants.id);
    printfulProductVariants.updatedAt = new Date();
    return setDoc(documentReference, printfulProductVariants);
}

const getAllPrintfulProductVariants = async () => {
    let searchQuery = query(collectionReference);
    const printfulProductVariants = await getDocs(searchQuery);
    return preparePrintfulProductVariantsList(printfulProductVariants);
}

const getSinglePrintfulProductVariants = async (printfulProductVariantsId) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulProductVariantsId);
    const printfulProductVariantsDoc = await getDoc(documentReference);
    return prepareSinglePrintfulProductVariants(printfulProductVariantsDoc);
}

const searchPrintfulProductVariants = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const printfulProductVariantsResult = await getDocs(searchQuery);
    return preparePrintfulProductVariantsList(printfulProductVariantsResult);
}

const searchPrintfulProductVariantsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPrintfulProductVariantsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
            searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const printfulProductVariantsResult = await getDocs(searchQuery);
    return preparePrintfulProductVariantsList(printfulProductVariantsResult);
}

const preparePrintfulProductVariantsList = (printfulProductVariantsResult) => {
    const printfulProductVariantsList = [];

    _.forEach(printfulProductVariantsResult.docs, printfulProductVariantsDoc => {
        printfulProductVariantsList.push(prepareSinglePrintfulProductVariants(printfulProductVariantsDoc));
    });

    return printfulProductVariantsList;
}


const prepareSinglePrintfulProductVariants = (printfulProductVariantsDoc) => {
    const printfulProductVariants = printfulProductVariantsDoc.data();
    printfulProductVariants.id = printfulProductVariantsDoc.id;
    return printfulProductVariants;
}
